/* eslint-disable class-methods-use-this */
import { IInboundTaskDocument } from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';

import { GetUserInProgressInboundDocumentAndInvoiceResponse } from './type';

class SwipeRxWmsApiInboundTaskDocument extends SwipeRxWmsApi {
  private readonly basePath: string;

  constructor() {
    super(SwipeRxAPIResources.INBOUND_TASK_DOCUMENT);
    this.basePath = `/${this.apiResource}`;
  }

  async getUserInProgressInboundTaskDocumentAndInvoice(): Promise<GetUserInProgressInboundDocumentAndInvoiceResponse> {
    try {
      const response = await this.get(
        `${this.basePath}/in-progress-document-invoice`,
      );
      return response.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getInProgressInboundTaskDocument(
    inboundTaskNumber: string,
  ): Promise<IInboundTaskDocument> {
    try {
      const response = await this.get(`${this.basePath}/in-progress`, {
        inbound_task_number: inboundTaskNumber,
      });
      return response.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }
}

export const swipeRxWmsApiInboundTaskDocument =
  new SwipeRxWmsApiInboundTaskDocument();
